var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showGoToBtn)?_c('div',{staticClass:"go-top-btn"},[_c('button',{on:{"click":_vm.gotTop}},[_c('img',{attrs:{"src":require("@/assets/icons/d-down-nav-w.svg"),"alt":""}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }